<template>
	<NuxtLayout
		name="sales"
		class="bg-gradient-to-br from-purple-900 to-purple-500 flex flex-col justify-center"
	>
		<div class="container max-w-screen-sm py-24 flex flex-col gap-12">
			<div class="flex flex-col gap-4">
				<AtomTitle
					tag="h1"
					size="5xl"
					class="text-white"
				>
					Aanmelden voor een gratis proefles
				</AtomTitle>
				<div class="flex flex-col gap-2 text-paragraph-size-lg text-purple-50">
					<p>
						Geweldig dat je een les met ons wilt uitproberen! Vul onderstaand formulier in om
						eenmalig <strong>gratis en vrijblijvend</strong> deel te kunnen nemen aan een van onze trainingen.
					</p>
					<p>
						Wij nemen binnen 1 werkdag contact op om een training in te plannen.
					</p>
				</div>
			</div>
			<AtomCard class="p-12">
				<OrganismFormLeadSgtTrial />
			</AtomCard>
		</div>
	</NuxtLayout>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Aanmelden Proefles Small Group Training in Uden | Fit Hier',
	ogTitle: 'Meld je aan – Gratis Proefles Small Group Training in Uden',
	description: 'Meld je gratis aan voor een proefles Small Group Training bij Fit Hier in Uden. Maximaal 6 deelnemers en persoonlijke coaching. Reserveer je plek!',
});
</script>
